import { Component, Input, OnInit, OnDestroy, AfterViewInit, ElementRef, ViewChild, Renderer2, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../../account/shared/auth.service';
import { CartService } from '../../my-cart/shared/cart.service';
import { CartItem } from '../../models/cart-item.model';
import { Product } from '../../models/product.model';
import { User } from '../../models/user.model';
import { slugify } from '../../utils/slugify';
import { ProductService } from '../../my-products/shared/product.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-my-item-product',
  templateUrl: './my-item-product.component.html',
  styleUrls: ['./my-item-product.component.scss']
})
export class MyItemProductComponent implements OnInit, OnDestroy {
  @ViewChild('productImage') productImage!: ElementRef;
  private userSubscription: Subscription;
  @Input() public product: Product;
  @Input() public displayMode: string;
  public user: User;
  public productCategory: string | null;
  public productSlug: string = '';

  constructor(
    private cartService: CartService,
    private authService: AuthService,
    private productService: ProductService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit() {
    this.userSubscription = this.authService.user.subscribe((user) => {
      this.user = user;
    });
    this.productCategory = Object.keys(this.product.categories)[0] || 'product';
    this.productSlug = slugify(this.product.name);
    // if (this.product.familles) {
    //   this.productCategory = Object.keys(this.product.familles).find(
    //     key => this.product.familles![key] === true
    //   ) || null;
    // }
    // this.productSlug = slugify(this.product.name);
  }

  onAddToCart() {
    // Créer l'élément d'animation
    const image = this.productImage.nativeElement.cloneNode(true) as HTMLElement;
    const rect = this.productImage.nativeElement.getBoundingClientRect();

    // Position de départ
    this.renderer.setStyle(image, 'position', 'fixed');
    this.renderer.setStyle(image, 'top', `${rect.top}px`);
    this.renderer.setStyle(image, 'left', `${rect.left}px`);
    this.renderer.setStyle(image, 'width', `${rect.width}px`);
    this.renderer.setStyle(image, 'height', `${rect.height}px`);
    this.renderer.setStyle(image, 'z-index', '1000');
    this.renderer.setStyle(image, 'border-radius', '50%');
    this.renderer.setStyle(image, 'object-fit', 'cover');
    this.renderer.setStyle(image, 'transition', 'all 0.7s cubic-bezier(0.4, 0, 0.2, 1)');
    this.renderer.setStyle(image, 'box-shadow', '0 4px 12px rgba(0, 0, 0, 0.2)');

    this.document.body.appendChild(image);

    // Déclencher l'animation vers une position fixe en haut à droite
    setTimeout(() => {
      this.renderer.setStyle(image, 'top', '20px');
      this.renderer.setStyle(image, 'right', '20px');
      this.renderer.setStyle(image, 'left', 'auto');
      this.renderer.setStyle(image, 'width', '30px');
      this.renderer.setStyle(image, 'height', '30px');
      this.renderer.setStyle(image, 'opacity', '0.5');
      this.renderer.setStyle(image, 'transform', 'scale(0.5)');
    }, 50);

    // Vérifier si le produit existe déjà dans le panier
    const existingItems = this.cartService.getItems();
    const existingItem = existingItems.find(item =>
      item.product.id === this.product.id &&
      item.priceIndex === 0
    );

    if (existingItem) {
      // Si le produit existe, augmenter sa quantité
      existingItem.quantity += 1;
      this.cartService.updateItem(existingItem);
    } else {
      // Si le produit n'existe pas, l'ajouter au panier
      const cartItem: CartItem = {
        product: {...this.product,detail : null},
        quantity: 1,
        price: this.product.price,
        priceIndex: 0
      };
      this.cartService.addItem(cartItem);
    }

    // Nettoyage après l'animation
    setTimeout(() => {
      image.remove();
    }, 800);
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
  }

  onSelectProduct(): void {
    this.productService.setProduct(this.product);
  }
}
